import { useEffect, useRef } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import NotificationCenterTabs from '../notification-center/NotificationCenterTabs';
import TravelInboxPage from './TravelInboxPage';

/**
 * Messages shell under Inbox IA v2「通知」owner（FE-IA-V2-03）。
 * 桌面：列表 + 對話；平板／手機：既有兩段 route。Secondary 訊息｜通知 共用。
 */
export default function TravelMessagesShell() {
  const thread = useMatch('/messages/:conversationId');
  const threadId = thread?.params?.conversationId;
  const shellRef = useRef(null);
  useEffect(() => {
    if (!threadId) return undefined;
    const node = shellRef.current;
    const fit = () => {
      if (!node) return;
      const viewport = window.visualViewport;
      const bottomNav = document.querySelector('.travel-bottom-nav');
      const bottomHeight = bottomNav && getComputedStyle(bottomNav).display !== 'none' ? bottomNav.getBoundingClientRect().height : 0;
      node.style.height = `${Math.max(120, (viewport?.height || window.innerHeight) + (viewport?.offsetTop || 0) - node.getBoundingClientRect().top - bottomHeight - 8)}px`;
    };
    fit(); window.addEventListener('resize', fit); window.visualViewport?.addEventListener('resize', fit); window.visualViewport?.addEventListener('scroll', fit);
    return () => { window.removeEventListener('resize', fit); window.visualViewport?.removeEventListener('resize', fit); window.visualViewport?.removeEventListener('scroll', fit); };
  }, [threadId]);
  return (
    <div
      ref={shellRef}
      className={thread ? 'travel-messages-shell is-split' : 'travel-messages-shell'}
      data-testid="travel-messages-shell"
      data-inbox-owner="notifications"
    >
      <NotificationCenterTabs active="messages" />
      {thread ? (
        <div className="travel-messages-shell__inbox">
          <TravelInboxPage variant="rail" />
        </div>
      ) : null}
      <Outlet />
    </div>
  );
}
